import { render, staticRenderFns } from "./CphSidebarNavigationLink.vue?vue&type=template&id=541e7683&scoped=true&"
import script from "./CphSidebarNavigationLink.vue?vue&type=script&lang=js&"
export * from "./CphSidebarNavigationLink.vue?vue&type=script&lang=js&"
import style0 from "./CphSidebarNavigationLink.vue?vue&type=style&index=0&id=541e7683&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541e7683",
  null
  
)

export default component.exports